/**
 * Created by lzy 19-11-04
 * 添加头条号账号模块
 */
'use strict';
angular.module('productManageMentToutiaohaoAccountAddModule', []).controller('ProductManageMentToutiaohaoAccountAddCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService', 'item',
    function($scope, $modalInstance, $validation, trsHttpService, item) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            // $scope.data = {
            //     currUser: {
            //         sinaLoginUserName: '',
            //         is_original: '0'
            //     }
            // };
            $scope.data = {
                currUser: {
                    CHNLNAME: item ? item.CHNLNAME : '',
                    CHANNELID: item ? item.CHANNELID : 0,
                    LINKURL: item ? item.LINKURL : '',
                    CHNLDESC: item ? item.CHNLDESC : '',
                    ISPAICHONG: item ? item.ISPAICHONG : '',
                    CKMSIMDAYRANGE: item ? item.CKMSIMDAYRANGE : '',
                    // language: item.LANGUAGE,
                    serviceId: 'mlf_toutiaoconfig',
                    methodName: 'saveChannel',
                }
            };
        }

        /**
         * [checkProperty description] 是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.data.currUser.is_original = $scope.data.currUser.is_original == '0' ? '1' : '0';
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            // var params = {
            //     serviceid: 'mlf_toutiaoconfig',
            //     methodName: 'saveChannel',
            //     CHANNELID: 0,
            //     CHNLNAME: $scope.data.currUser.toutiaoName,
            //     LINKURL: $scope.data.currUser.link,
            //     CHNLDESC: $scope.data.currUser.description,
            //     // language:'zh-cn',
            //     IS_ORIGINAL: 0
            // };
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(['./lib/js-base64/base64.js'], function() {
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.data.currUser, 'post', true).then(function(data) {
                        $modalInstance.close({result: true, data: data});
                    }, function(data) {
                        $modalInstance.close({result: false, data: data});
                    });
                });
            });
        };
    }
]);
